import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import {
  ChangeInvestmentInstructionSubmissionAccountFormGroup,
  ChangeInvestmentInstructionSubmissionFormGroup
} from '../form-groups/change-investment-instruction-submission-form-group';
import { AccountTypeIdEnum } from '../../../../../models/enum/shared/account-type-id.enum';
import { FormArray } from '@angular/forms';

@Component({
  selector: 'app-investment-instruction-account-type-container',
  templateUrl: './investment-instruction-account-type-container.component.html',
  styleUrls: [
    './investment-instruction-account-type-container.component.scss',
    '../change-investment-instructions-submission-form.component.scss'
  ],
  changeDetection: ChangeDetectionStrategy.Default
})
export class InvestmentInstructionAccountTypeContainerComponent {
  @Input({ required: true }) form!: ChangeInvestmentInstructionSubmissionFormGroup;
  @Input({ required: true }) formSubmitted!: boolean;
  @Input({ required: true }) radioControlId!: string;
  @Input({ required: true }) accountTypeId!: AccountTypeIdEnum;
  @Input({ required: true }) accounts!: FormArray<ChangeInvestmentInstructionSubmissionAccountFormGroup>;
  @Input({ required: true }) accountsHidden!: boolean;
}
